module.exports = __webpack_public_path__ + "img/15.dd000ab0.png";